module.exports = __webpack_public_path__ + "static/media/landing-ico-1.6cb61d5e.svg";